module.exports = __webpack_public_path__ + "static/media/55.4cfb2e87.jpg";